import React, {useEffect} from 'react';
import AccountMenu from "./AccountMenu";
import {useSelector} from "react-redux";
import {selectUserAccount} from "../../stores/account/account.selectors";
import LoginButton from "../../views/PopUps/LoginPopUp/LoginButton";
import SignUpButton from "./SignUpButton";

export default function UserPanel ( props ) {
const account = useSelector(selectUserAccount);

const isOnRegisterPage = window.location.pathname === '/register';

    return (
        <div className={"UserPanel"}>
            {account ? <AccountMenu />
                : <div className='signUpLoginButtons'>
                    <SignUpButton visible={!isOnRegisterPage} />
                    <LoginButton/>
                </div>}
        </div>
    );
}